import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

// No ConvexProvider here, unlike apps/retells: the browser half of checkout
// never talks to Convex. It polls this app's own Worker (`GET
// /api/session/:id`), which holds the only credential that can read the
// checkout deployment. A shopper's browser is not a trusted party on the
// money path and gets no direct data access.

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
